// Experience Section Data
// Edit this file to add or update work experience
// To add a new experience, add a new object to the experiences array

export const experienceData = {
  heading: "Experience",
  description: "My professional journey in cloud infrastructure and DevOps",
  experiences: [
    {
      id: 1,
      company: "Pick2Solutions",
      position: "Junior Platform Engineer",
      duration: "August 2025 - Present",
      location: "Atlanta, GA",
      description: "Junior Platform Engineer focused on Infrastructure as Code and cloud platform engineering, supporting multiple commercial and government clients across Azure, Azure Government, and AWS environments.",
      achievements: [
        "Designed and maintained reusable Terraform modules for multiple client environments, improving standardization and deployment reliability",
        "Worked extensively with Azure Commercial, Azure Government (US GovCloud), and AWS while adhering to compliance and security requirements",
        "Automated infrastructure provisioning and updates using CI/CD pipelines, reducing manual effort and configuration drift",
        "Implemented and supported networking, identity, and security components including VNets/VPCs, IAM/RBAC, and private endpoints",
        "Assisted in troubleshooting, optimizing cloud resources, and improving platform stability for client workloads"
      ],
      technologies: ["Terraform", "Azure", "Azure Government", "AWS", "GitHub Actions", "CI/CD", "Networking", "IAM/RBAC", "Linux"]
    },
    {
      id: 2,
      company: "Freelancer",
      position: "AWS DevOps Engineer (Part-Time)",
      duration: "February 2025 - Present",
      location: "Remote (Atlanta, GA)",
      description: "Part-time AWS DevOps Engineer providing cloud architecture, automation, and CI/CD solutions for clients.",
      achievements: [
        "Designed and implemented scalable AWS architectures using EC2, S3, RDS, and VPC",
        "Built and integrated CI/CD pipelines using GitHub Actions for automated deployments",
        "Configured IAM roles and policies to enforce secure access controls",
        "Implemented CloudWatch monitoring and logging for better visibility and reliability",
        "Optimized storage costs using S3 lifecycle policies and best practices"
      ],
      technologies: ["AWS", "EC2", "S3", "RDS", "VPC", "IAM", "CloudWatch", "GitHub Actions", "CI/CD"]
    },
    {
      id: 3,
      company: "Salsoft Technologies",
      position: "DevOps Engineer",
      duration: "June 2024 - January 2025",
      location: "Karachi, Pakistan",
      description: "DevOps Engineer responsible for cloud infrastructure design, automation, networking, and CI/CD across AWS and Azure for multiple projects and environments.",
      achievements: [
        "Migrated a 3-tier Node.js application to Azure VMs using Azure DevOps CI/CD, reducing deployment cycle time by 50%",
        "Designed and implemented secure cloud architectures on AWS and Azure using VPCs, Security Groups, and NACLs",
        "Automated infrastructure provisioning using Terraform, reducing environment setup time by 40%",
        "Implemented monitoring and reliability improvements using AWS CloudWatch",
        "Built automated backup systems using Bash and cron, storing up to 5TB of daily backups in Amazon S3 with 100% recovery success"
      ],
      technologies: ["Terraform", "AWS", "Azure", "Azure DevOps", "Jenkins", "Git", "Linux", "Python", "Bash", "CloudWatch", "S3", "Networking"]
    },
    {
      id: 4,
      company: "Systems Limited",
      position: "Azure DevOps Intern",
      duration: "2020",
      location: "Karachi, Pakistan",
      description: "Azure DevOps Intern focused on CI/CD automation, cloud resource management, and infrastructure optimization across Azure and AWS.",
      achievements: [
        "Enhanced CI/CD pipelines using PowerShell, increasing deployment speed by 40%",
        "Managed and optimized Azure resources including VMs and SSL certificates",
        "Reduced deployment-related issues by automating repetitive operational tasks",
        "Supported AS2 server operations for secure data exchange",
        "Gained hands-on experience managing cloud infrastructure across Azure and AWS"
      ],
      technologies: ["Azure", "AWS", "PowerShell", "Terraform", "CI/CD", "Linux", "Networking"]
    }
  ]
};

